import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import PageHeader from '../components/ui/PageHeader';
import LoadingScreen from '../components/ui/LoadingScreen';
import {
  IconPackage,
  IconBuilding,
  IconLink,
  IconChevronRight,
  IconMail,
  IconChat,
  IconKey,
} from '../components/ui/Icons';

function Dashboard() {
  const [stats, setStats] = useState({
    products: 0,
    tenants: 0,
    partners: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [productsRes, tenantsRes] = await Promise.all([
        api.post('/product/list', {}),
        api.post('/tenant/list', { page: 1, limit: 500 }),
      ]);

      const tenants = tenantsRes.data.data?.tenants || [];

      setStats({
        products: productsRes.data.data?.products?.length || 0,
        tenants: tenantsRes.data.data?.pagination?.total ?? tenants.length,
        partners: tenants.filter((tenant) => tenant.kind === 'partner').length,
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingScreen message="Loading dashboard..." />;
  }

  const quickLinks = [
    { to: '/products', label: 'Manage Products', icon: IconPackage },
    { to: '/partners', label: 'Manage Partners', icon: IconBuilding },
    { to: '/tenants', label: 'Manage Tenants', icon: IconBuilding },
    { to: '/tenant-products', label: 'Link Products', icon: IconLink },
    { to: '/email-config', label: 'Email Settings', icon: IconMail },
    { to: '/whatsapp-config', label: 'WhatsApp Settings', icon: IconChat },
    { to: '/oauth-config', label: 'OAuth Settings', icon: IconKey },
  ];

  return (
    <div className="page">
      <PageHeader
        title="Dashboard"
        description="Overview of your platform — products, tenants, and configuration at a glance."
      />

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--indigo">
            <IconPackage width={22} height={22} />
          </div>
          <div>
            <div className="stat-card__value">{stats.products}</div>
            <div className="stat-card__label">Products</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--rose">
            <IconBuilding width={22} height={22} />
          </div>
          <div>
            <div className="stat-card__value">{stats.tenants}</div>
            <div className="stat-card__label">Tenants</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--indigo">
            <IconBuilding width={22} height={22} />
          </div>
          <div>
            <div className="stat-card__value">{stats.partners}</div>
            <div className="stat-card__label">Partners</div>
          </div>
        </div>
      </div>

      <h2 className="section-title">Quick actions</h2>
      <div className="quick-links">
        {quickLinks.map(({ to, label, icon: Icon }) => (
          <Link key={to} to={to} className="quick-link">
            <Icon width={18} height={18} />
            {label}
            <IconChevronRight width={16} height={16} />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;

